module.exports = __webpack_public_path__ + "static/image_4-d3e695644149a1cf2aba48c77ffc9a70.jpg";